import LoadingButton from "@/components/common/form/loading-button";
import { deleteCookie } from "cookies-next";
import { signOut } from "next-auth/react";
import { twMerge } from "tailwind-merge";

interface ICancelIntegrationProps {
  className?: string;
}

const CancelIntegration = ({ className }: ICancelIntegrationProps) => {
  return (
    <div
      className={twMerge(
        "flex items-center justify-center hover:underline",
        className
      )}
    >
      <LoadingButton
        theme="text"
        onClick={() => {
          deleteCookie("cnb_i_token");
          deleteCookie("cnb_i_type");
          signOut({
            callbackUrl: "/v2/signup/email",
          });
        }}
      >
        연동 없이 회원가입
      </LoadingButton>
    </div>
  );
};

export default CancelIntegration;
